import { Box, Typography } from "@mui/material";

const FilterBox = ({ label, children }: { label: string; children: React.ReactNode }) => (
  <Box
    sx={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: "30px",
    }}
  >
    <Typography variant="body14SemiBold" component="span" sx={{ fontWeight: 600 }}>
      {label}
    </Typography>
    {children}
  </Box>
);

export default FilterBox;
